import styled from 'styled-components';

export const ClientLogoStyled = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    align-self: center;
    margin-bottom: 80px;

    img {
        width: 34%;
        max-width: 280px;
        min-width: 180px;
        height: auto;
    }
`;

export default ClientLogoStyled;
